/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Title/view.blocks to change it.
import * as fromData from 'Simple/Data'
import DataVaxiomPersonTitleSelect from 'DesignSystem/Data/DataVaxiom/DataVaxiomPerson/DataVaxiomPersonTitleSelect/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Title({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/Edit/NonPatient/Details/Title",
  onChange
  
}) {
let editRelationFromPersonRecordTitleValueData = fromData.useDataValue({ viewPath,
context: 'edit_relation',
path: 'from_person_record.title',
})
let editRelationFromPersonRecordTitleChangeData = fromData.useDataChange({ viewPath,
context: 'edit_relation',
path: 'from_person_record.title',
})
  return (<React.Fragment
>
<DataVaxiomPersonTitleSelect
  viewPath={`${viewPath}/DataVaxiomPersonTitleSelect`}
 size="medium"
 data="edit_relation.from_person_record.title"
 value={editRelationFromPersonRecordTitleValueData}
 onChange={editRelationFromPersonRecordTitleChangeData}
/>
{children}
</React.Fragment>)
}